import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

export class DataRecordHelper {
    private dialog: DialogUtils;

    constructor(DialogUtils: DialogUtils) {
        this.dialog = DialogUtils;
    }

    openDataRecord(disableSave: boolean, hideCancel: boolean): void {
        let parentEl = angular.element(document.body);

        this.dialog.show({
            parent: parentEl,
            component: "vc-data-record-dialog",
            bindToController: true,
            escapeToClose: false,
            clickOutsideToClose: false,
            locals: {
                disableSave: disableSave,
                hideCancel: hideCancel,
            },
            size: "large",
            class: "data-record-dialog",
            id: "data-record-dialog",
            ariaLabel: "Data Record Dialog",
        });
    }
}

angular.module("dataRecord").service("DataRecordHelper", DataRecordHelper);
